export class State {
  constructor(value) {
    this.value = value | {};
  }

  loading = false;
  error = null;
  valid = null;
  value = {};
  lock = false;

  async trigger(cb, { onSuccess, onError } = {}) {
    this.error = null;
    this.loading = true;
    try {
      this.value = await cb();
      if (onSuccess) {
        onSuccess(this.value);
      }
    } catch (error) {
      this.error = error;
      if (onError) onError(error);
    } finally {
      this.loading = false;
    }
  }
}
